import React, { useState, useEffect } from 'react';
import { JarvisProvider } from './context/JarvisContext';
import BootScreen    from './components/Boot/BootScreen';
import AppShell      from './components/Shared/AppShell';
import ErrorBoundary from './components/ErrorBoundary';
import ApiKeySetup   from './components/Settings/ApiKeySetup';
import OverlayWindow from './components/ScreenMonitor/OverlayWindow';
import InstallPWA    from './components/Shared/InstallPWA';
import EnableNotifications from './components/Shared/EnableNotifications';
import EnableMicrophone from './components/Shared/EnableMicrophone';
import PositionTracker from './components/Shared/PositionTracker';
import { THEME }     from './styles/theme';
import { seedRule }  from './services/storage';
import { greet }     from './services/voiceService';
import { DEFAULT_RULES } from './data/defaultRules';

const GLOBAL_CSS = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: ${THEME.colors.bg}; color: ${THEME.colors.text}; }
  ::-webkit-scrollbar { width: 4px; height: 4px; }
  ::-webkit-scrollbar-track { background: rgba(255,255,255,0.03); }
  ::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.3); border-radius: 2px; }
  ::-webkit-scrollbar-thumb:hover { background: rgba(0,212,255,0.6); }
  input, textarea, select, button { font-family: inherit; }
  a { color: inherit; }
`;

// Overlay mode: loaded in the floating transparent window
const IS_OVERLAY = window.location.hash === '#overlay';

function App() {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    DEFAULT_RULES.forEach(rule => seedRule(rule));
  }, []);

  // Greet on first full boot (not overlay window)
  useEffect(() => {
    if (!IS_OVERLAY) {
      const timer = setTimeout(() => greet(), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  if (IS_OVERLAY) {
    return (
      <>
        <style>{`
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { background: transparent !important; color: #e2e8f0; overflow: hidden; }
          input, textarea, select, button { font-family: 'Courier New', monospace; }
          ::-webkit-scrollbar { width: 3px; }
          ::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.25); border-radius: 2px; }
        `}</style>
        <OverlayWindow />
      </>
    );
  }

  return (
    <>
      <style>{GLOBAL_CSS}</style>
      <ApiKeySetup />
      <ErrorBoundary>
        <JarvisProvider>
          {!booted
            ? <BootScreen onComplete={() => setBooted(true)} />
            : (
              <>
                <AppShell />
                {/* Inside the Provider (need activeScreen, to suppress
                    themselves on the Chat screen — that already has its
                    own bottom input row, and stacking a banner on top of
                    it while mid-conversation was a real overlap bug,
                    confirmed via a real mobile screenshot) and after
                    boot (no point cluttering the boot animation). */}
                <InstallPWA />
                <EnableNotifications />
                <EnableMicrophone />
                <PositionTracker />
              </>
            )
          }
        </JarvisProvider>
      </ErrorBoundary>
    </>
  );
}

export default App;
